import styled from 'styled-components';

export const ProgressCircleContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 10px;
  width: ${props => props.width || '190px'};
  height: ${props => props.width || '180px'};
`;

export const CircleSvg = styled.svg`
  transform: rotate(-90deg);
  width: 100%;
  height: 100%;
`;

export const CircleBackground = styled.circle`
  fill: none;
  stroke: #F3F4F6;
  stroke-width: ${props => props.strokeWidth || 15};
`;

export const CirclePending = styled.circle`
  fill: none;
  stroke: #E5E7EB;
  stroke-width: 25;
  stroke-dasharray: ${props => props.circumference};
  stroke-dashoffset: ${props => props.dashoffset};
  transition: stroke-dashoffset 1s ease-in-out;
`;

export const CircleSent = styled.circle`
  fill: none;
  stroke: #10B981;
  stroke-width: 25;
  stroke-dasharray: ${props => props.circumference};
  stroke-dashoffset: ${props => props.dashoffset};
  transition: stroke-dashoffset 1s ease-in-out;
`;

export const CircleTaken = styled.circle`
  fill: none;
  stroke: #9CA3AF;
  stroke-width: 25;
  stroke-dasharray: ${props => props.circumference};
  stroke-dashoffset: ${props => props.dashoffset};
  transition: stroke-dashoffset 1s ease-in-out;
`;

export const PercentageText = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 16px;
  font-weight: 600;
  color: #1F2937;
`;